window.initBtnFillHover = function initBtnFillHover() {
  const btnFillHoverElsArr = document.querySelectorAll('.btn-fill-hover');

  if (btnFillHoverElsArr.length) {
    btnFillHoverElsArr.forEach((btnFillHoverEl) => {
      if (!btnFillHoverEl.classList.contains('is-init-btn-fill-hover')) {
        btnFillHoverEl.classList.add('is-init-btn-fill-hover');

        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('btn__content');

        while (btnFillHoverEl.firstChild) {
          contentWrapper.appendChild(btnFillHoverEl.firstChild);
        }

        btnFillHoverEl.appendChild(contentWrapper);

        const btnFillBgEl = document.createElement('div');
        btnFillBgEl.classList.add('btn-fill-hover__fill-bg');
        btnFillHoverEl.appendChild(btnFillBgEl);

        const handleOrigin = (e) => {
          const rect = btnFillHoverEl.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          btnFillBgEl.style.left = `${x}px`;
          btnFillBgEl.style.top = `${y}px`;
        };

        const handleHoverColor = () => {
          const computedStyle = getComputedStyle(btnFillHoverEl);
          const borderColor = computedStyle.borderColor;

          if (
              borderColor &&
              borderColor !== 'transparent' &&
              borderColor !== 'rgba(0, 0, 0, 0)'
          ) {
            const index = [...btnFillHoverElsArr].indexOf(btnFillHoverEl);
            const varName = `--btn-hover-color-${index}`;

            btnFillHoverEl.style.setProperty(varName, borderColor);
            btnFillHoverEl.style.setProperty(
                '--btn-hover-color',
                borderColor
            );
          }
        };

        btnFillHoverEl.addEventListener('mouseenter', (e) => {
          if (window.innerWidth > 1024) {
            handleOrigin(e);
          }
          handleHoverColor();
        });

        btnFillHoverEl.addEventListener('mouseleave', (e) => {
          if (window.innerWidth > 1024) {
            handleOrigin(e);
          }
        });

        handleHoverColor();
      }
    });
  }
};

initBtnFillHover();